import React, { Component } from 'react';
import Cookie from "./Cookie.jsx";
import Header from "./Header.jsx";

export default class HeaderContainer extends Component {
    render() {
        return (
            <div>
                <Cookie/>
                <Header/>
            </div>

        );
    }
}



// WEBPACK FOOTER //
// frontend/src/modules/template/HeaderContainer.jsx